<template>
  <span>
    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :page="page"
      clean-layout
      :row-buttons="true"
    >
    </crud-layout-search>
    <jt-docs-viewer
      v-if="showDoc"
      ref="docsModal"
      pdf
      :src="src"
      @hide="closeDoc"
    />
  </span>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable, JtDocs } from 'jtech-webcomps'
import { repository } from 'jtech'

const { page, pageTable, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [page],
  name: 'ClientFile',
  components: {
    CrudLayoutSearch,
    page,
    pageTable,
    JtDataTable,
    jtDocsViewer: JtDocs.JtDocsViewer
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ClientFile extends Vue {
  showDoc = false;
  src = null;
  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  async icDownload ({ button, params, page, controller }) {
    if (params.name) {
      const filePath = this.createFilePath(params)
      const file = await this.downloadFile(filePath)
      const link = document.createElement('a')

      link.download = params.name
      link.href = URL.createObjectURL(file)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  async icDetalhar ({ button, params, page, controller }) {
    if (params.name) {
      const filePath = this.createFilePath(params)
      const file = await this.downloadFile(filePath)
      const link = document.createElement('a')
      this.src = URL.createObjectURL(file)
      this.showDoc = true
      this.$nextTick(() => {
        this.$refs.docsModal.show()
      })
    }
  }

  createFilePath (params) {
    return params.client + '/' + params.fileTypeDescription + '/' + params.name
  }

  closeDoc () {
    this.showDoc = false
  }

  async downloadFile (filePath) {
    return await repository.downloadFile(filePath, null, 'CLIENT_FILE')
  }

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton('icDownload', this.icDownload)
      this.$refs.crudLayoutSearch.onButton('icDetalhar', this.icDetalhar)
    } catch (error) {
      console.error(error)
    }
  }
}
export default ClientFile
</script>
<style lang="stylus" scoped></style>
